import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas
} from '@api/commonApi.js';
export default {
    methods: {
        // 获取修改单条
        getList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: id
            };
            this.loading = true;
            this.lists = [{
                name: '',
                tel: ''
            }]
            this.ProvList = [],
                $http.get("/api/Agent/GetById", params).then(res => {
                    let {
                        Data,
                        Cnt
                    } = res.data;
                    this.loading = false;
                    util.doResult(this, res, () => {
                        this.lists[0].name = Data.Customer
                        this.lists[0].tel = Data.Tel
                        let len = Data.listProv.length
                        for (let i = 0; i < len; i++) {
                            this.ProvList.push({
                                ProvId: Data.listProv[i].ProvId,
                                CityId: Data.listProv[i].CityId
                            })
                            this.GetProvCitys(Data.listProv[i].ProvId)
                        }
                        // 添加、删除按钮
                        for (let i = 1; i < this.ProvList.length; i++) {
                            this.isDelBtnShow.push(true); //删除按钮
                            this.isAddBtnShow.unshift(false); //新增按钮
                        }
                        this.form.DataType = Data.DataType
                        if (Data.BuessionPartId == 0) {
                            this.form.BuessionPartId = ""
                        } else {
                            this.form.BuessionPartId = Data.BuessionPartId
                        }


                    });
                });
        },
        // 提交
        AddAgentEmployee() {
            // var params = {
            //     Sid: this.$store.state.sysSid,
            //     Session: this.$store.state.sysSession,
            // };
            //params = Object.assign({}, params, this.form);
            $http.post("/api/Agent/AddAgentEmployeeEx", this.form).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.$emit('close')
                    this.close()
                });
            });
        },
        // 修改
        ModifyAgentEmployee() {
            // var params = {
            //     Sid: this.$store.state.sysSid,
            //     Session: this.$store.state.sysSession,
            // };
            //params = Object.assign({}, params, this.form);
            this.form2.BuessionPartId = this.form.BuessionPartId
            $http.post("/api/Agent/ModifyAgentEmployeeEx", this.form2).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.$emit('reloadList')
                    this.close()
                });
            });
        },
        // 获取市
        GetProvCitys(ProvinceId, index) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ProvinceId: ProvinceId
            };
            GetCitys(params).then(res => {
                util.doResult(this, res, () => {
                    this.CityList = res.data.Data;
                    if (index) {
                        let oldCityId = this.ProvList[index].CityId
                        // this.ProvList[index].CityId不匹配则清空
                        let len = this.CityList.length
                        for (let i = 0; i < len; i++) {
                            if (this.CityList[i].Id == oldCityId) {
                                this.ProvList[index].CityId = this.CityList[i].Id
                                return
                            } else {
                                this.ProvList[index].CityId = ''
                            }
                        }
                    }

                });

            })
        },
        // 获取业务部门列表
        GetBuessionPartList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 1000
            };
            this.departmentList = []
            $http.get("api/Agent/GetBuessionPartList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.departmentList = Data
                });
            });
        }

    },

}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/setEmployeeArea/services.js